import React, {useState} from 'react';

import AppLogo from './AppLogo'
import TopMenu from './TopMenu'
export const TopHeader =(props)=>{
     
    return  <div className={props.isTrailAccount?"main-content trail":"main-content "}>
                <AppLogo/>
                <TopMenu/>
            </div>

   
}
export default TopHeader;